var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTableViewIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.325,
    height: 16.678,
    viewBox: "0 0 16.325 16.678",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Union_410",
    "data-name": "Union 410",
    d: "M-3899.966-90.073a4.7,4.7,0,0,1-3.355-1.2,4.576,4.576,0,0,1-1.267-3.39v-7.576a4.467,4.467,0,0,1,1.271-3.343,4.746,4.746,0,0,1,3.351-1.173h7.089a4.694,4.694,0,0,1,3.422,1.24,4.49,4.49,0,0,1,1.192,3.278V-94.6a4.485,4.485,0,0,1-1.266,3.345,4.743,4.743,0,0,1-3.356,1.178Zm-3.366-12.163v7.576a3.02,3.02,0,0,0,3.366,3.331h7.081c2.171,0,3.367-1.16,3.367-3.267v-7.639a3.24,3.24,0,0,0-.827-2.39,3.486,3.486,0,0,0-2.532-.869h-7.089C-3902.136-105.495-3903.332-104.337-3903.332-102.235Zm3.449,7.617a.627.627,0,0,1-.627-.628.626.626,0,0,1,.627-.627h6.922a.627.627,0,0,1,.628.627.628.628,0,0,1-.628.628Zm0-3a.627.627,0,0,1-.627-.628.627.627,0,0,1,.627-.628h6.922a.628.628,0,0,1,.628.628.628.628,0,0,1-.628.628Zm0-3a.627.627,0,0,1-.627-.628.626.626,0,0,1,.627-.627h6.922a.627.627,0,0,1,.628.627.628.628,0,0,1-.628.628Z",
    transform: "translate(3904.588 106.751)",
    fill: "#a49dc8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTableViewIcon);
export default __webpack_public_path__ + "static/media/table_view_icon.8c4a7f2e9585bc7e7e9952af2588f531.svg";
export { ForwardRef as ReactComponent };